import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReportService } from '@services/report.service';
import { UploadStatus, ValidatorService } from '@shared/models/fileupload';
import { catchError, Observable, Subject, throwError } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class PowerbivalidatorService implements ValidatorService {
	private statusSubject: Subject<UploadStatus> = new Subject<UploadStatus>();
	public statusSubject$ = this.statusSubject.asObservable();

	constructor(
		private translate: TranslateService,
		private reportService: ReportService,
		private router: Router,
		private http: HttpClient,
	) {}

	validate(files: File[], fields: object[]) {
		console.log(`PowerBIValidator: Processing file: ${files[0].name}`);
		const formData: FormData = new FormData();
		formData.append('file', files[0]);
		const reportTitle = (fields['powerbi_report_title'] as FormControl).getRawValue();
		const error = false; // Nothing to validate in a PBIX file...

		if (error) {
			// Catch errors here after validation of file and show notification to user
			const errorMessage = this.translate.instant('insights.administration.reports.upload.uploadererrormessage', {
				interpolatedParam1: 'p1',
			});
			this.statusSubject.next({ status: 'error', data: errorMessage });
		} else {
			this.reportService
				.getPowerBiMetaData(reportTitle)
				.pipe(catchError(this.handleError))
				.subscribe((s3data) => {
					// We should probably wrap the FileReader in an observable to avoid the old school .onload handler, see:
					// https://gist.github.com/iansinnott/3d0ba1e9edc3e6967bc51da7020926b0#file-rx-file-reader-js

					const fileReader = new FileReader();
					fileReader.readAsArrayBuffer(files[0]);
					fileReader.onload = () => {
						// Possibly detect file size (max ~200kb) to eliminate uploads of pbix files that contain datasets (Excel, ...) ?
						const renamedFile = new File([fileReader.result], s3data.key);
						this.http
							.put(s3data.url, renamedFile, {
								headers: s3data.requiredHeaders,
							})
							.pipe(catchError(this.handleError))
							.subscribe({
								next: (uploadStatus) => {
									console.log('In powerbi validate next', uploadStatus);
									this.statusSubject.next({
										status: 'success',
										data: uploadStatus,
									});
									// this.router.navigate(['insights/administration/adminreports']);
									setTimeout(() => {
										this.reportService.synchronizeWithPowerBI('REPORT', true, true);
									}, 5000);
								},
								error: (error: Error) => {
									console.log('In powerbi validate error', error);
									this.statusSubject.next({ status: 'error', data: error });
								},
							});
					};
				});
		}
	}

	handleError(error): Observable<never> {
		const msg = `${error?.status}: ${error?.message}`;
		return throwError(() => new Error(msg));
	}
}
